function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122 241C189.379 241 244 233.613 244 224.5V206.5C244 215.613 189.379 223 122 223C54.6213 223 0 215.613 0 206.5V224.5C0 233.613 54.6213 241 122 241Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M122 241C189.379 241 244 233.613 244 224.5V206.5H122H0V224.5C0 233.613 54.6213 241 122 241Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 206.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 206.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122 223C189.379 223 244 215.613 244 206.5C244 206.5 244 205.5 243.5 205.5C238.5 210 224.144 213.187 192 216C155 219.237 113.5 219.864 72.5 218C59.3234 217.401 6.5 213.5 0.500003 205C0 206 0 206.5 0 206.5C0 215.613 54.6213 223 122 223Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M128 219C195.379 219 250 211.613 250 202.5V184.5C250 193.613 195.379 201 128 201C60.6213 201 6 193.613 6 184.5V202.5C6 211.613 60.6213 219 128 219Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M128 219C195.379 219 250 211.613 250 202.5V184.5H128H6V202.5C6 211.613 60.6213 219 128 219Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 184.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 184.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128 201C195.379 201 250 193.613 250 184.5C250 184.5 250 183.5 249.5 183.5C244.5 188 230.144 191.187 198 194C161 197.237 119.5 197.864 78.5 196C65.3234 195.401 12.5 191.5 6.5 183C6 184 6 184.5 6 184.5C6 193.613 60.6213 201 128 201Z",
  fill: "url(#paint5_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M124 196C191.379 196 246 188.613 246 179.5V161.5C246 170.613 191.379 178 124 178C56.6213 178 2 170.613 2 161.5V179.5C2 188.613 56.6213 196 124 196Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M124 196C191.379 196 246 188.613 246 179.5V161.5H124H2V179.5C2 188.613 56.6213 196 124 196Z",
  fill: "url(#paint6_linear)",
  fillOpacity: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 161.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 161.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint7_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M124 178C191.379 178 246 170.613 246 161.5C246 161.5 246 160.5 245.5 160.5C240.5 165 226.144 168.187 194 171C157 174.237 115.5 174.864 74.5 173C61.3234 172.401 8.5 168.5 2.5 160C2 161 2 161.5 2 161.5C2 170.613 56.6213 178 124 178Z",
  fill: "url(#paint8_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M127 174C194.379 174 249 166.613 249 157.5V139.5C249 148.613 194.379 156 127 156C59.6213 156 5 148.613 5 139.5V157.5C5 166.613 59.6213 174 127 174Z",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M127 174C194.379 174 249 166.613 249 157.5V139.5H127H5V157.5C5 166.613 59.6213 174 127 174Z",
  fill: "url(#paint9_linear)",
  fillOpacity: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 139.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 139.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint10_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M127 156C194.379 156 249 148.613 249 139.5C249 139.5 249 138.5 248.5 138.5C243.5 143 229.144 146.187 197 149C160 152.237 118.5 152.864 77.5 151C64.3234 150.401 11.5 146.5 5.5 138C5 139 5 139.5 5 139.5C5 148.613 59.6213 156 127 156Z",
  fill: "url(#paint11_linear)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M131 149C198.379 149 253 141.613 253 132.5V114.5C253 123.613 198.379 131 131 131C63.6213 131 9 123.613 9 114.5V132.5C9 141.613 63.6213 149 131 149Z",
  fill: "currentColor"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M131 149C198.379 149 253 141.613 253 132.5V114.5H131H9V132.5C9 141.613 63.6213 149 131 149Z",
  fill: "url(#paint12_linear)",
  fillOpacity: 0.25
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 114.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 114.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint13_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M131 131C198.379 131 253 123.613 253 114.5C253 114.5 253 113.5 252.5 113.5C247.5 118 233.144 121.187 201 124C164 127.237 122.5 127.864 81.5 126C68.3234 125.401 15.5 121.5 9.5 113C9 114 9 114.5 9 114.5C9 123.613 63.6213 131 131 131Z",
  fill: "url(#paint14_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M122 127C189.379 127 244 119.613 244 110.5V92.5C244 101.613 189.379 109 122 109C54.6213 109 0 101.613 0 92.5V110.5C0 119.613 54.6213 127 122 127Z",
  fill: "currentColor"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M122 127C189.379 127 244 119.613 244 110.5V92.5H122H0V110.5C0 119.613 54.6213 127 122 127Z",
  fill: "url(#paint15_linear)",
  fillOpacity: 0.25
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 92.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 92.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint16_linear)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M122 109C189.379 109 244 101.613 244 92.5C244 92.5 244 91.5 243.5 91.5C238.5 96 224.144 99.1874 192 102C155 105.237 113.5 105.864 72.5 104C59.3234 103.401 6.5 99.5 0.500003 91C0 92 0 92.5 0 92.5C0 101.613 54.6213 109 122 109Z",
  fill: "url(#paint17_linear)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M132 108C199.379 108 254 100.613 254 91.4999V73.5C254 82.6127 199.379 90 132 90C64.6213 90 10 82.6127 10 73.5V91.4999C10 100.613 64.6213 108 132 108Z",
  fill: "currentColor"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M132 108C199.379 108 254 100.613 254 91.4999V73.5H132H10V91.4999C10 100.613 64.6213 108 132 108Z",
  fill: "url(#paint18_linear)",
  fillOpacity: 0.25
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 73.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 73.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint19_linear)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M132 90C199.379 90 254 82.6127 254 73.5C254 73.5 254 72.5 253.5 72.5C248.5 77 234.144 80.1874 202 83C165 86.2375 123.5 86.8636 82.5 85C69.3234 84.401 16.5 80.5 10.5 72C10 73 10 73.5 10 73.5C10 82.6127 64.6213 90 132 90Z",
  fill: "url(#paint20_linear)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M124 82.9999C191.379 82.9999 246 75.6126 246 66.4999V48.5C246 57.6127 191.379 65 124 65C56.6213 65 2 57.6127 2 48.5V66.4999C2 75.6126 56.6213 82.9999 124 82.9999Z",
  fill: "currentColor"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M124 82.9999C191.379 82.9999 246 75.6126 246 66.4999V48.5H124H2V66.4999C2 75.6126 56.6213 82.9999 124 82.9999Z",
  fill: "url(#paint21_linear)",
  fillOpacity: 0.25
});

var _ref39 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 48.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 48.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint22_linear)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M124 65C191.379 65 246 57.6127 246 48.5C246 48.5 246 47.5 245.5 47.5C240.5 52 226.144 55.1874 194 58C157 61.2375 115.5 61.8636 74.5 60C61.3234 59.401 8.5 55.5 2.5 47C2 48 2 48.5 2 48.5C2 57.6127 56.6213 65 124 65Z",
  fill: "url(#paint23_linear)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M127 57.9999C194.379 57.9999 249 50.6126 249 41.4999V23.5C249 32.6127 194.379 40 127 40C59.6213 40 5 32.6127 5 23.5V41.4999C5 50.6126 59.6213 57.9999 127 57.9999Z",
  fill: "currentColor"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M127 57.9999C194.379 57.9999 249 50.6126 249 41.4999V23.5H127H5V41.4999C5 50.6126 59.6213 57.9999 127 57.9999Z",
  fill: "url(#paint24_linear)",
  fillOpacity: 0.25
});

var _ref44 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 23.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 23.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint25_linear)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M127 40C194.379 40 249 32.6127 249 23.5C249 23.5 249 22.5 248.5 22.5C243.5 27 229.144 30.1874 197 33C160 36.2375 118.5 36.8636 77.5 35C64.3234 34.401 11.5 30.5 5.5 22C5 23 5 23.5 5 23.5C5 32.6127 59.6213 40 127 40Z",
  fill: "url(#paint26_linear)"
});

var _ref47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 244,
  y1: 241,
  x2: 118,
  y2: 241,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 195,
  x2: 122,
  y2: 217,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -3.63368e-8,
  y1: 223,
  x2: 244,
  y2: 223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250,
  y1: 219,
  x2: 124,
  y2: 219,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 143,
  y1: 173,
  x2: 128,
  y2: 195,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 6,
  y1: 201,
  x2: 250,
  y2: 201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 246,
  y1: 196,
  x2: 120,
  y2: 196,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 139,
  y1: 150,
  x2: 124,
  y2: 172,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2,
  y1: 178,
  x2: 246,
  y2: 178,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 249,
  y1: 174,
  x2: 123,
  y2: 174,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 142,
  y1: 128,
  x2: 127,
  y2: 150,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 5,
  y1: 156,
  x2: 249,
  y2: 156,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 253,
  y1: 149,
  x2: 127,
  y2: 149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 146,
  y1: 103,
  x2: 131,
  y2: 125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 9,
  y1: 131,
  x2: 253,
  y2: 131,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 244,
  y1: 127,
  x2: 118,
  y2: 127,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 137,
  y1: 81,
  x2: 122,
  y2: 103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: -3.63368e-8,
  y1: 109,
  x2: 244,
  y2: 109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 254,
  y1: 108,
  x2: 128,
  y2: 108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 147,
  y1: 62,
  x2: 132,
  y2: 84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 10,
  y1: 89.9999,
  x2: 254,
  y2: 89.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 246,
  y1: 83,
  x2: 120,
  y2: 83,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: 139,
  y1: 37,
  x2: 124,
  y2: 59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: 2,
  y1: 64.9999,
  x2: 246,
  y2: 64.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: 249,
  y1: 58,
  x2: 123,
  y2: 58,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear",
  x1: 142,
  y1: 12,
  x2: 127,
  y2: 34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear",
  x1: 5,
  y1: 39.9999,
  x2: 249,
  y2: 39.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})));

function Svg9Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 245,
    viewBox: "0 0 259 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9Chip);
export default __webpack_public_path__ + "static/media/9chip.64df1ce2.svg";
export { ForwardRef as ReactComponent };